<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading" class="box-overflow normal edit-list">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">แก้ไขหลักสูตร</h2>
      </div>

      <ManageCourseForm
        @updateCourse="updateCourse"
        :course="course"
        type="update"
      />

      <div class="pd-b-2">
        <SubjectList v-if="course" :courseName="course.name" :subjectNumber="typeof course.subjectNumber != 'undefined'?course.subjectNumber:null"/>
      </div>

      <div class="pd-b-2">
        <FeedbackList
          v-if="course"
          :feedbackList="course.assessment"
          :courseName="course.name"
          @fetchCouseById="fetchCouseById"
        />
      </div>
      
      <el-dialog 
        title="กำลังอัพโหลดข้อมูล..." 
        :visible.sync="dialogProgress" 
        :show-close="false" 
        :close-on-click-modal="false" 
        :close-on-press-escape="false" 
        top="25vh" 
        :width="widthMax < 767.98?'80%':null"
        class="text-center padding-top-10">
          <el-progress type="circle" :percentage="progress" :width="widthMax < 767.98?200:250" :color="[
                {color: '#ff8f8c', percentage: 30},
                {color: '#ffb800', percentage: 60},
                {color: '#04cc24', percentage: 80}
            ]"></el-progress>
      </el-dialog>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ManageCourseForm from "@/components/manageCourse/ManageCourseForm";
import SubjectList from "@/components/subject/SubjectList";
import FeedbackList from "@/components/feedback/FeedbackList";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    ManageCourseForm,
    SubjectList,
    FeedbackList
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      courseId: "",
      course: null,
      loading: true,
      dialogProgress:false,
      progress:0,
      widthMax: window.innerWidth,
    };
  },
  mounted() {
    this.setParams();
    this.fetchCouseById();
    this.fetchCourseList()
    window.addEventListener("resize", this.resize);
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    resize() {
      this.widthMax= window.innerWidth
    },
    updateCourse(data, del) {
      this.progress = 0
      this.dialogProgress = true

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      formData.append("name", data.courseName);
      formData.append("statusCourse", data.statusCourse);

      formData.append(
        "durationTime",
        JSON.stringify({
          open: data.courseDistanceDate[0],
          close: data.courseDistanceDate[1],
        })
      );
      formData.append(
        "totalStudyTime",
        JSON.stringify({
          hours: 0,
          minute: 0,
        })
      );

      if (typeof data.courseImageIntro.raw != "undefined") {
        formData.append("illustration", data.courseImageIntro.raw);
      }

      if (del.courseImageIntroDel != "") {
        formData.append("delIllustration", del.courseImageIntroDel);
      }

      if (typeof data.courseVideoIntro.raw != "undefined") {
        formData.append("introduction", data.courseVideoIntro.raw);
      }

      if (del.courseVideoIntroDel != "") {
        formData.append("delIntroduction", del.courseVideoIntroDel);
      }

      data.courseDocuments.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("studyDocument", item.raw);
        }
      });

      del.courseDocumentsDel.map((item, index) => {
        formData.append("delStudy", item);
      });

      formData.append("courseDescription", data.courseDescription);

      data.courseDescriptionFile.map((item, index) => {
        if (item.raw != null && typeof item.raw != "undefined") {
          formData.append("attachDescription", item.raw);
        }
      });

      del.courseDescriptionFileDel.map((item, index) => {
        formData.append("delDesc", item);
      });

      formData.append("percent", data.coursePercentPass);
      formData.append("countPostTest", data.courseSetCount);
      formData.append("subjectNumber", data.courseSubject);

      let interval = setInterval(() => {
        if (this.progress < 80) {
          this.progress += 2
        }
        setTimeout(() => {
          if (this.progress < 95) {
            this.progress += 1
          }
        }, 1000);
       

      }, 1500);

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`course/${this.courseId}`, formData, config)
        .then((res) => {
      
          if (res.data.success) {
            this.fetchCouseById();
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        }).finally(()=>{
          clearInterval(interval)
          this.progress = 95
           setTimeout(() => {
              this.progress = 100
              setTimeout(() => {
                   this.dialogProgress = false
              }, 500);
           }, 500);
   
        })
    },
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
        }
      }
    },
    fetchCouseById() {
      HTTP.get(`course/${this.courseId}`)
        .then((res) => {

          if (res.data.success) {
            this.course = res.data.obj;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCouseById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>
